// Language file for Booking page. Th

export default {
  content: {
    title: "จอง",
    searchPlaceholder: "ค้นหาผู้สมัคร, ตำเเหน่งงาน",
    searchPlaceholder2: "ค้นหาผู้สมัคร",
    searchPlaceholder3: "ค้นหาผู้จองคิว, หัวข้อโต๊ะ",
    searchPlaceholder4: "ค้นหาผู้จองคิว",
    listOfBooking: "รายการที่นัดหมาย",
    noDataFound: "ไม่พบข้อมูล",
    candidatesTracking: "ติดตามสถานะผู้สมัคร",
    bookerTracking: "ติดตามผู้จองคิว",

    allInterviewDate: "วันเวลาทั้งหมด",
    selectInterviewStatus: "เลือกสถานะ",
    showOnlyRegisteredTimes: "แสดงเฉพาะเวลาที่ลงทะเบียน",
    downloadBooking: "ดาวน์โหลดข้อมูลการนัดหมาย",
  },

  tableHead: {
    interviewDate: "วันที่จอง",
    interviewTime: "เวลาจอง",
    candidateName: "ชื่อผู้สมัคร",
    appointmentBooker: "ผู้จองคิว",
    jobPosition: "ตำเเหน่ง",
    status: "สถานะ",

    category: "หมวดหมู่",
    applyDate: "วันที่สมัคร",
  },

  preview: {
    detail: "รายละเอียด",
    detailFund: "รายละเอียดทุน",
    edit: "แก้ไขข้อมูล"
  },

  title: {
    createDetail: "รายละเอียดการสร้างโต๊ะ",
    createDetailFund: "รายละเอียดการสร้างทุน",
    business: "หน่วยงาน",
    subject: "หัวข้อโต๊ะ",
    subjectFund: "หัวข้อทุน",
    qualification: "รายละเอียดคุณสมบัติ",
    qualificationFund: "รายละเอียดทุน",
    jobDescription: "รายละเอียดตำแหน่งงาน",
    jobDescriptionCondition: "เงื่อนไข",
  },
  rule: {
    selectBusiness: "เลือกหน่วยงาน",
    enterSubject: "ระบุหัวข้อโต๊ะ",
    enterSubjectFund: "ระบุหัวข้อทุน",
    subjectRequired: "กรุณาระบุหัวข้อโต๊ะ",
    subjectRequiredFund: "กรุณาระบุหัวข้อทุน",
    noLeadingSpace: "ห้ามเว้นวรรคที่ตำแหน่งเริ่มต้น",
    singleSpaceOnly: "ควรเว้นวรรคเพียง 1 ครั้ง",
    maxLength200: "พิมพ์ได้ไม่เกิน 200 ตัวอักษร",

    changeStatusTo: "เปลี่ยนสถานะเป็น",
    comment: "ความคิดเห็น",
    enterComment: "ระบุความคิดเห็น",
    recommendRequired: "กรุณาแนะนำหน่วยงานที่เกี่ยวข้อง",
    optional: "ไม่บังคับ"
  },
  btn: {
    saveDraft: "บันทึกฉบับร่าง",
    post: "โพสรับคิว",
    postFund: "โพสทุน",
  },
};
